import {USER_BOARD} from '../values';

export const MESSAGES_HISTORY_ROUTES = [
  {
    path: USER_BOARD + "/messages/history",
    loadChildren: "./pages/messages-history-page/messages-history-page.module#MessagesHistoryPageModule"
  }
]



// WEBPACK FOOTER //
// ./src/app/shared/routes/messages-history.routes.ts